import $router from "@/router";
import { Toast } from "vant";
import { channelKey } from "@/utils/variable";
export default {
    install(Vue, options) {
        Vue.prototype.$primary = "#ffca3b";
        Vue.prototype.$back = () => {
            if (window.history.length > 1) {
                $router.back();
            } else {
                $router.push("/");
            }
        };
        Vue.prototype.$copy = val => {
            let addInp = document.createElement("input");
            document.body.appendChild(addInp);
            addInp.value = val;
            addInp.select(); // 选择对象用户定义的代码区域
            document.execCommand("Copy"); //原生copy方法执行浏览器复制命令
            addInp.remove();
            Toast.success("复制成功");
        };
        Vue.prototype.$getImageUrl = filePath => {
            let uploadsUrl = process.env.VUE_APP_BASEURL;
            if (!filePath) {
                return "";
            } else if (filePath.indexOf("http") == 0) {
                return filePath;
            } else {
                //上传地址以 / 结尾且文件路径也以 / 开头
                if (uploadsUrl.lastIndexOf("/") == uploadsUrl.length - 1 && filePath.indexOf("/") == 0) {
                    return uploadsUrl + filePath.substr(1);
                }
                //上传地址以 / 结尾且文件路径不以 / 开头   或   上传地址不以 / 结尾且文件路径以 / 开头
                if (
                    (uploadsUrl.lastIndexOf("/") == uploadsUrl.length - 1 && filePath.indexOf("/") != 0) ||
                    (uploadsUrl.lastIndexOf("/") != uploadsUrl.length - 1 && filePath.indexOf("/") == 0)
                ) {
                    return uploadsUrl + filePath;
                }
                //上传地址、文件路径都以 / 结尾/开头
                if (uploadsUrl.lastIndexOf("/") != uploadsUrl.length - 1 && filePath.indexOf("/") != 0) {
                    return uploadsUrl + "/" + filePath;
                }
                return "";
            }
        };
        Vue.prototype.$getParam = function getQueryVariable(variable) {
            if (window.location.hash.includes("?")) {
                var query = window.location.hash.split("?")[1];
                var vars = query.split("&");
                for (var i = 0; i < vars.length; i++) {
                    var pair = vars[i].split("=");
                    if (pair[0] == variable) {
                        return pair[1];
                    }
                }
                return "";
            } else {
                return "";
            }
        };
        Vue.prototype.$backPre = () => {
            let channel = localStorage[channelKey];
            if (channel == "01") {
                Fw.closeCurWebPanel();
            } else {
                history.back(-1);
            }
        };
        Vue.prototype.$Toast = Toast;
        Vue.prototype.$toDetail = id => {
            $router.push("/detail?id=" + id);
        };
        // Vue.prototype.$primary = "rgb(226, 61, 61)";
        Vue.prototype.$primary = "#f0d9af";
    },
};
